import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  getrankeStande: [],
  loading: false,
  error: null
}

// getters
const getters = {
  getrankeStande (state) {
    return state.getrankeStande
  },
  getrankeStand: (state) => (id) => {
    return state.getrankeStande.find(getrankeStand => getrankeStand.id === id)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadGetrankeStande ({commit}) {
    commit('setLoading', true)
    console.log('Getränkestände laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('getranke_zahlen').orderBy('datum', 'desc')
    .onSnapshot(snapshot => {
      const getrankeStande = []
      snapshot.forEach(doc => {
        getrankeStande.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedGetrankeStande', getrankeStande)
        commit('setLoading', false)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createGetrankeStand ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('getranke_zahlen').add(payload)
      .then(key => {
        commit('createGetrankeStand', {
          ...payload,
          id: key.id
        })
      })
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteGetrankeStandeData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('getranke_zahlen').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteGetrankeStand', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateGetrankeStandData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('getranke_zahlen').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateGetrankeStand', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedGetrankeStande (state, payload) {
    state.getrankeStande = payload
  },
  createGetrankeStand (state, payload) {
    state.getrankeStande.push(payload)
  },
  updateGetrankeStand (state, payload) {
    const getrankeStand = state.getrankeStande.find(getrankeStand => {
      return getrankeStand.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        getrankeStand[key] = payload[key]
      }
    })
  },
  deleteGetrankeStand (state, payload) {
    let array = state.getrankeStande
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.getrankeStande = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/getrankeStand_alt.js